import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/base/icon';

class Alerts extends React.Component {
  static propTypes = {
    alerts: PropTypes.array,
    onError: PropTypes.func,
  };

  render() {
    var alert = function (alerts) {
      if (!alerts || alerts.length === 0) return;

      return (
        <div className="alert alert-warning alert-dismissible">
          <button
            type="button"
            onClick={this.close}
            className="close"
            aria-label="Close"
          >
            <Icon name="close" />
          </button>
          <ul>
            {alerts.map(function (error, idx) {
              return <li key={idx}>{error}</li>;
            }, this)}
          </ul>
        </div>
      );
    }.call(this, this.props.alerts);
    return <div id="alert-container">{alert}</div>;
  }

  close = (e) => {
    if (this.props.onAlert) {
      this.props.onAlert([]);
    }
  };
}

export default Alerts;
